export default "__VITE_PUBLIC_ASSET__b3deac32__"